import { useState, useEffect } from "react";
import Header from "./components/Header";
import { isAuthenticated } from "../../store/action/auth";
import { getRates, deleteRates } from "../../store/action/rates";
import { getUser, updateUserOnLocal } from "../../store/action/user";
import ReactLoading from "react-loading";
import RatesTable from "./components/RatesTable";
import ModalRatesForm from "./components/ModalRatesForm";

export default function Rates(props) {
  const { token, user } = isAuthenticated();
  const [openModal, setOpenModal] = useState(false);
  const [rates, setRates] = useState([]);
  const [currentRates, setCurrentRates] = useState({});
  const [fetchLoading, setFetchLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    _fetchData();
  }, [currentPage]);

  const _fetchData = async () => {
    try {
      setFetchLoading(true);
      const resRates = await getRates(token, currentPage, 5);
      const { data: resUser } = await getUser(token);
      if (resRates.success && resUser.success) {
        setRates(resRates.rate);
        setTotalPages(resRates.total_pages);
        updateUserOnLocal(resUser, () => {});
      } else {
        alert("Gagal mengambil data, silahkan refresh halaman");
      }
      setFetchLoading(false);
    } catch (error) {
      console.log(error);
      setFetchLoading(false);
      alert("Gagal mengambil data, silahkan refresh halaman");
    }
  };

  const onClickEdit = (idx) => {
    setCurrentRates(rates[idx]);
    setOpenModal(true);
  };

  const onClickDelete = async (idx) => {
    try {
      const res = await deleteRates(token, rates[idx]);
      if (res.success) {
        alert("Data berhasil dihapus");
        _fetchData(); // Refresh data after deletion
      } else {
        alert("Gagal menghapus data, silahkan refresh halaman");
      }
    } catch (error) {
      console.log(error);
      alert("Gagal menghapus data, silahkan refresh halaman");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <Header />
      {fetchLoading ? (
        <div className="text-center flex justify-center">
          <div className="flex py-5 items-center">
            <ReactLoading type="bubbles" color="#4c1d95" height={54} width={75} />
            <h5 className="mt-6 ">
              <strong> mengambil rates</strong>
            </h5>
          </div>
        </div>
      ) : (
        <div className="border rounded">
          <RatesTable
            data={rates}
            loading={fetchLoading}
            onClickEdit={onClickEdit}
            onClickDelete={onClickDelete}
            user={user}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
      <ModalRatesForm
        show={openModal}
        onClose={() => setOpenModal(false)}
        useType="edit"
        data={currentRates}
      />
    </div>
  );
}
